import { RefObject, useEffect, useMemo } from "react"
import { parseValidFloat } from "../../../helpers/widget"
import { IFCViewerV4ConfigOptions } from "./config"
import { RemoteProxy } from "penpal"
import { IFrameApi } from "./shared/iframe-api"
import { OpaqueSparqlResults } from "../../../helpers/sparqlResultHelpers"
import { DEFAULT_WIDGET_CONFIG } from "../../default-widget-config"
import { ViewerConfig } from "./shared/viewer-config"

type SyncViewerConf = {
  widgetConfig: IFCViewerV4ConfigOptions
  iframeApiRef: RefObject<RemoteProxy<IFrameApi> | undefined>
  iframeLoadedAt: number
  sparqlResults: OpaqueSparqlResults | undefined
}

export function useSyncViewerConfig(conf: SyncViewerConf) {
  const widgetConfig = conf.widgetConfig
  const viewerConfig = useMemo(() => ({
    display: {
      mode: widgetConfig.displayMode ?? "normal",
      transparencyOpacity: widgetConfig.displayMode === "transparent"
        ? parseValidFloat(widgetConfig.transparencyOpacity)
        : undefined,
      predefinedColors: widgetConfig.predefinedColors,
      assignRandomColorsToTags: widgetConfig.assignRandomColorsToTags ?? DEFAULT_WIDGET_CONFIG.IFCViewerV4.assignRandomColorsToTags,
      legendSorting: widgetConfig.legendSorting ?? DEFAULT_WIDGET_CONFIG.IFCViewerV4.legendSorting
    },
    selection: {
      zoomToSelection: Boolean(widgetConfig.zoomToSelection)
    }
  } satisfies ViewerConfig), [
    widgetConfig.displayMode,
    widgetConfig.transparencyOpacity,
    widgetConfig.predefinedColors,
    widgetConfig.assignRandomColorsToTags,
    widgetConfig.legendSorting,
    widgetConfig.zoomToSelection
  ])

  useEffect(function syncViewerConfig() {
    if (!conf.iframeApiRef.current) return
    conf.iframeApiRef.current.setViewerConfig(viewerConfig).catch(console.error)
  }, [ conf.iframeApiRef, conf.iframeLoadedAt, viewerConfig
  ])

  useEffect(function syncSparqlResults() {
    if (!conf.sparqlResults) return
    if (!conf.iframeApiRef.current) return
     conf.iframeApiRef.current.setSparqlResults(conf.sparqlResults)
      .catch(console.error)
  }, [ conf.iframeApiRef, conf.iframeLoadedAt, conf.sparqlResults ])
}
